import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import { MyHrUsersFilterBar, MyHrUsersImportWrapper } from "my-hr/components";
import { users, usersIsMobile } from "my-hr/configs/my-hr-table-defs";
import { useMyHrUsers } from "my-hr/hooks";
import {
  OcCard,
  OcDataTable,
  OcPageNameTitle,
  OcPageTransition,
} from "oc/components";
import { initialTableData } from "oc/configs/initial-table-data";
import { useOcTableState, useOcIsMobile } from "oc/hooks";

export const MyHRAdminUsersPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const isMobile = useOcIsMobile();

  const tableId = "usersListTable";
  const [tableData, setTableData] = useOcTableState(tableId, {
    ...initialTableData,
    sortField: "fullname",
    pageSize: 5,
    filterField: "active",
    filterSelected: ["active"],
  });

  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

  const { data, loading } = useMyHrUsers({
    sortField: tableData?.sortField,
    sortDirection: tableData?.sortDirection,
    filterField: tableData?.filterField,
    filterSelected: tableData?.filterSelected,
    searchField: tableData?.searchField,
    searchText: tableData?.searchText,
    page: tableData?.page,
    pageSize: tableData?.pageSize,
  });

  const handleNewUser = () => {
    history.push("/my-hr/create-new-user");
  };

  const handleSelectRow = (o: any) => {
    if (isMobile) {
      history.push(`/my-hr/user-profile/${o?.row?.code}`);
    } else {
      history.push(`/my-hr/user-profile/${o?.code}`);
    }
  };

  const onSelectRow = (o: { _id?: string; code: string }) => {
    if (isMobile) {
      setSelectedRowId(selectedRowId === o?._id ? null : (o?._id ?? null));
    } else {
      handleSelectRow(o);
    }
  };

  const handleAddGroupRole = () => {
    history.push("/my-hr/users/add-group-roles");
  };

  const handleInactivateGroup = () => {
    history.push("/my-hr/users/inactivate-group");
  };

  const handleRemoveGroup = () => {
    history.push("/my-hr/users/remove-group");
  };

  const handleSendGroupPassords = () => {
    history.push("/my-hr/users/send-group-passwords");
  };

  const tableDef = isMobile ? usersIsMobile : users;

  const filteredTableDef = {
    id: users?.id,
    columns: users?.columns?.filter(
      (column) =>
        !usersIsMobile?.columns?.some(
          (mobileColumn) => mobileColumn?.id === column?.id,
        ),
    ),
  };

  return (
    <OcPageTransition>
      <OcPageNameTitle
        title={t("MY_HR_ADMIN_USERS_PAGE_TITLE")}
        goBack={false}
      />
      <Box padding={isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px"}>
        <MyHrUsersImportWrapper />
        <OcCard label={t("MY_HR_USERS")}>
          <>
            <MyHrUsersFilterBar
              onNewUser={handleNewUser}
              onAddGroupRole={handleAddGroupRole}
              onInactivateGroup={handleInactivateGroup}
              onRemoveGroupRole={handleRemoveGroup}
              onSendGroupPasswords={handleSendGroupPassords}
              tableData={tableData}
              setTableData={(data) => setTableData({ ...tableData, ...data })}
              loading={loading}
              dataLength={data?.rows?.length}
            />
            <Box paddingTop="26px">
              <OcDataTable
                data={data}
                loading={loading && data?.rows?.length === 0 ? true : false}
                tableDef={tableDef}
                tableData={tableData}
                setTableData={setTableData}
                pagination={true}
                onSelectRow={onSelectRow}
                filteredTableDef={filteredTableDef}
                selectedRowId={selectedRowId ?? undefined}
                handleMoreButton={handleSelectRow}
              />
            </Box>
          </>
        </OcCard>
      </Box>
    </OcPageTransition>
  );
};

export default MyHRAdminUsersPage;
